import React from "react";
import { Link } from "react-router-dom";
import Socials from "../Socials";

const Header = () => {
  return (
    <header className="absolute z-30 w-full flex items-center px-16 xl:px-0 xl:h-[90px]">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-y-6 py-8">
          <Link to={"/"}>
            <img
              src="https://i.postimg.cc/52xYdJxb/oie-1-Z5g-MR4o-Jcm1.png"
              width={220}
              height={48}
              alt=""
            />
          </Link>
          <Socials />
        </div>
      </div>
    </header>
  );
};

export default Header;
